import { useSoftphone } from '@/store/softphone';

/**
 * ArkConnect agent state machine — drives chrome bg color, topbar context,
 * sidebar accents, status pill.
 *
 *   kuyruk-disi: Login yapmış ama kuyruğa girmemiş
 *   kuyrukta:    Hazır, çağrı bekliyor
 *   active:      Aktif çağrı (ringing/calling/in_call)
 *   mola:        Molada (bir sonraki faz'da break store eklendiğinde aktif)
 *
 * Şu an softphone store'undan derive ediliyor. İlerde mola state'i için
 * useBreakStore eklendiğinde burası priority'leyecek (mola > active > queue).
 */

export type AgentState = 'kuyruk-disi' | 'kuyrukta' | 'active' | 'mola';

export function useAgentState(): AgentState {
  const state = useSoftphone((s) => s.state);
  const queueIn = useSoftphone((s) => s.queueIn);
  const queueAction = useSoftphone((s) => s.queueAction);
  const breakMode = useSoftphone((s) => s.breakMode);

  // Queue feature code (*62/*63/*64/*65) sırasında — chrome'u "active" göstermek
  // yerine hedef state'e optimistik geçiş yap. Kullanıcı toggle çevirdiğinde
  // anlık görsel cevap alır, watchdog/hangup gerçek değişikliği teyit eder.
  if (queueAction) {
    if (queueAction.kind === 'pause') return 'mola';
    // Moladan dönüş artık kuyruğa OTOMATİK sokmaz → kuyruk-dışı (agent kendi girer).
    if (queueAction.kind === 'resume') return 'kuyruk-disi';
    return queueAction.kind === 'login' ? 'kuyrukta' : 'kuyruk-disi';
  }
  if (state === 'in_call' || state === 'ringing' || state === 'calling') return 'active';
  if (breakMode) return 'mola';
  if (queueIn) return 'kuyrukta';
  return 'kuyruk-disi';
}

export const AGENT_STATE_LABEL: Record<AgentState, string> = {
  'kuyruk-disi': 'Kuyruk dışı',
  'kuyrukta':    'Kuyrukta',
  'active':      'Görüşmede',
  'mola':        'Molada',
};

export const AGENT_STATE_DOT: Record<AgentState, string> = {
  'kuyruk-disi': 'bg-slate-400',
  'kuyrukta':    'bg-emerald-500',
  'active':      'bg-brand-500 animate-pulse',
  'mola':        'bg-amber-500',
};

export const AGENT_STATE_BORDER: Record<AgentState, string> = {
  'kuyruk-disi': 'border-slate-300 text-slate-700',
  'kuyrukta':    'border-emerald-300 text-emerald-800',
  'active':      'border-brand-200 text-brand-700',
  'mola':        'border-amber-300 text-amber-800',
};
